import app from 'app';
import Backbone from 'backbone';
import _ from 'underscore';
import ClientSideStorage from '@component/common/src/util/ClientSideStorage';

const setBeforeRequestHeader = function (xhr) {
  const deviceFingerPrint = ClientSideStorage.getPersistent('login365FingerPrint');
  if (ClientSideStorage.isStorageAvailable()) {
    xhr.setRequestHeader('X-Macys-DeviceFingerPrint', deviceFingerPrint);
  }
};

export default Backbone.Model.extend({
  urlRoot: '/account-xapi/api/notifications/user/',
  url() {
    let url = this.urlRoot + this.id;
    const pageType = this.attributes.pageType;
    const deviceType = this.attributes.deviceType;
    if (pageType && deviceType) {
      url = `${url}?_pageType=${pageType}&_deviceType=${deviceType}`;
    }
    return url;
  },

  sync(method, model, option) {
    let options = option;
    if (app.brand === 'mcom') {
      options = _.extend(options, {
        beforeSend: setBeforeRequestHeader,
      });
    }
    Backbone.Model.prototype.sync.call(this, method, model, options);
  },
});
